// extracted by mini-css-extract-plugin
export default {"addBlock":"MessageContent_addBlock__EDXWY"};